import module from './form.module'

export default module.name
